<template>
  <main class="login-shell">
    <section class="login-panel">
      <h1>Signing in</h1>
      <p v-if="error" class="notice error">{{ error }}</p>
      <p v-else>Checking your Orator Pro access…</p>
      <router-link v-if="error" to="/login">Back to sign in</router-link>
    </section>
  </main>
</template>

<script>
import { exchangeSharedSignIn } from "@/lib/api";
import { setSession } from "@/lib/auth";
import { finishSharedSignIn } from "@/lib/sharedSso";

export default {
  name: "SsoCallback",
  data: () => ({ error: "" }),
  async mounted() {
    try {
      const { accessToken, destination } = await finishSharedSignIn();
      const session = await exchangeSharedSignIn(accessToken);
      setSession(session);
      await this.$router.replace(destination);
    } catch (error) {
      this.error = "Shared sign-in could not be completed. Ask your MGC administrator to check your access.";
    }
  },
};
</script>

<style scoped>
.login-shell { min-height: 100vh; display: grid; place-items: center; padding: 1rem; }
.login-panel { width: min(100%, 420px); padding: 2rem; background: white; }
.error { color: #991b1b; margin: 1rem 0; }
</style>
